import { setCase } from "./casing";

const fullName = (
    user: { firstName?: string | null; lastName?: string | null },
    fallback = "Anonym",
): string => {
    if (!user.firstName?.trim() && !user.lastName?.trim()) return fallback;
    return `${user.firstName ? user.firstName + " " : ""}${
        user.lastName || ""
    }`;
};

const properName = (user: { firstName: string; lastName: string }) => {
    const firstName =
        (user.firstName && setCase("pascalCase")(user.firstName) + " ") || "";
    const lastName =
        (user.lastName?.[0] && " " + user.lastName?.[0].toUpperCase() + ".") ||
        "";
    return `${firstName}${lastName}`.trim();
};

export { fullName, properName };
